import React from "react";
import { FormattedMessage } from "react-intl";
import AsianEventScreenHeader1x2ML from "./AsianEventScreenHeader1x2ML";

const AsianEventScreenHDPHeader = (): React.JSX.Element => (
  <div className="asian-event-screen-market-headers">
    <div className="asian-event-screen-market-headers--market-types">
      <div className="col time">
        <FormattedMessage tagName="span" id="global-events-time" />
      </div>
      <div className="col event">
        <FormattedMessage tagName="span" id="global-events-event" />
      </div>
      <AsianEventScreenHeader1x2ML
        text1x2={"events-phase-FT-1x2"}
        textML={"event-markets-header-ftml"}
      />
      <div className="col ft-handicap">
        <FormattedMessage tagName="span" id="events-phase-FT-handicap" />
      </div>
      <div className="col ft-ou">
        <FormattedMessage tagName="span" id="events-phase-FT-OU" />
      </div>
      <AsianEventScreenHeader1x2ML
        text1x2={"events-phase-1H-1x2"}
        textML={"event-markets-header-1hml"}
      />
      <div className="col fh-handicap">
        <FormattedMessage tagName="span" id="events-phase-1H-handicap" />
      </div>
      <div className="col fh-ou">
        <FormattedMessage tagName="span" id="events-phase-1H-OU" />
      </div>
    </div>
  </div>
);

export default AsianEventScreenHDPHeader;
